import { render, staticRenderFns } from "./Atelier.vue?vue&type=template&id=675b7e14&"
import script from "./Atelier.vue?vue&type=script&lang=js&"
export * from "./Atelier.vue?vue&type=script&lang=js&"
import style0 from "./Atelier.vue?vue&type=style&index=0&id=675b7e14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports